module.exports = __webpack_public_path__ + "img/pressure_red.4b194460.svg";